require('./bootstrap');
require('./common_method');


import Vue from 'vue';
import Vuelidate from 'vuelidate';
import BootstrapVue from 'bootstrap-vue';

import App from './layout/App.vue';
import router from './router.js';
import i18n from './lang';
import VueSignaturePad from 'vue-signature-pad';

// Plugins
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(VueSignaturePad);

// Global Filters
require('./filters');

// Vue Instance
new Vue({
    el: '#app',
    components: {
        App
    },
    router,
    i18n
});